import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=5b80e1c6&scoped=true&"
import script from "./uploadImg.vue?vue&type=script&lang=js&"
export * from "./uploadImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=5b80e1c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80e1c6",
  null
  
)

export default component.exports